module.exports = __webpack_public_path__ + "img/6_staff-sp.35b0672d.gif";